
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'exchangeimprestIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'exchangeimprest',
				windowName: '售后备用金',
				windowType: 'modal',
				currentrow:null,
				list_footerField:[
					{field:'amt',toFixed:2}
				],
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500,2000],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

			
		},
		computed: {

		},

		methods: {

		},
		components: {
				
		}
	}
</script>
